<template>
  <div style="background: #f0f1f5">
    <HeaderComponent
      :pageContent="pageHeader"
       @change_language="handleHeaderClick"
      ></HeaderComponent> 
    <br />
    <br />
    <div class="container pb-4">
      <div class="row">
        <div class="col-md-6">
          <h1 style="font-weight: 500; color: #0c27bd">
            {{pageContent.title1}}<br />{{pageContent.title2}}
          </h1>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3524.192964795998!2d-82.48018252397202!3d27.95737601441855!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88c2c380e47f625d%3A0x3c6f5d33f4098a31!2s1730%20W%20Union%20St%2C%20Tampa%2C%20FL%2033607%2C%20USA!5e0!3m2!1sen!2sph!4v1738593277834!5m2!1sen!2sph"
            width="100%"
            height="450"
            style="border: 0"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
        <div class="col-md-5 offset-md-1">
          <p>
            {{pageContent.description1}}
          </p>
          <br />
          <div class="d-flex flex-row flex-wrap financial-container">
            <!-- Make it scroll to the sections  -->
            <div class="col-6 col-md-6 d-flex mb-3">
              <a
                href="javascript:void(0);"
                @click="scrollToSection('us-banks')"
                class="mx-1"
              >
                <img
                  src="assets/images/financial-resources/1.png"
                  class="img-fluid d-block"
                />
              </a>
            </div>
            <div class="col-6 col-md-6 d-flex mb-3">
              <a
                href="javascript:void(0);"
                class="mx-1"
                @click="scrollToSection('credit-unions')"

              >
                <img
                  src="assets/images/financial-resources/2.png"
                  class="img-fluid d-block"
                />
              </a>
            </div>
            <div class="col-6 col-md-6 d-flex mb-3">
              <a
                href="javascript:void(0);"
                @click="scrollToSection('filipino-banks')"
                class="mx-1"
              >
                <img
                  src="assets/images/financial-resources/3.png"
                  class="img-fluid d-block"
                />
              </a>
            </div>
            <div class="col-6 col-md-6 d-flex mb-3">
              <a
                href="javascript:void(0);"
                @click="scrollToSection('remittance')"
                class="mx-1"
              >
                <img
                  src="assets/images/financial-resources/4.png"
                  class="img-fluid d-block"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="row" id="us-banks">
        <div class="col-md-12">
          <h1>{{pageContent.section1_title}}</h1>
          <hr />
        </div>
        <div class="col-md-8">
          <h4 style="font-weight: 400">
            {{pageContent.section1_desc}}
          </h4>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="d-flex flew-row flex-wrap justify-content-center">
              <div class="grid" @click="goToLink('www.chase.com')">
                <figure class="effect-zoe">
                  <img
                    src="assets/images/financial-resources/us-bank/2.png"
                    alt="chase"
                    class="img-fluid"
                  />
                  <figcaption>
                    <p class="description">
                      {{pageContent.section1_item1}}
                    </p>
                  </figcaption>
                </figure>
              </div>

              <div class="grid" @click="goToLink('www.bankofamerica.com')">
                <figure class="effect-zoe">
                  <img
                    src="assets/images/financial-resources/us-bank/1.png"
                    alt="chase"
                    class="img-fluid"
                  />
                  <figcaption>
                    <p class="description">
                      {{pageContent.section1_item2}}
                    </p>
                  </figcaption>
                </figure>
              </div>

              <div class="grid" @click="goToLink('www.wellsfargo.com')">
                <figure class="effect-zoe">
                  <img
                    src="assets/images/financial-resources/us-bank/3.png"
                    alt="chase"
                    class="img-fluid"
                  />
                  <figcaption>
                    <p class="description">
                      {{pageContent.section1_item3}}
                    </p>
                  </figcaption>
                </figure>
              </div>

              <div class="grid" @click="goToLink('www.pnc.com')">
                <figure class="effect-zoe">
                  <img
                    src="assets/images/financial-resources/us-bank/4.png"
                    alt="chase"
                    class="img-fluid"
                  />
                  <figcaption>
                    <p class="description">
                      {{pageContent.section1_item4}}
                    </p>
                  </figcaption>
                </figure>
              </div>

              <div class="grid" @click="goToLink('www.citi.com')">
                <figure class="effect-zoe">
                  <img
                    src="assets/images/financial-resources/us-bank/5.png"
                    alt="chase"
                    class="img-fluid"
                  />
                  <figcaption>
                    <p class="description">
                      {{pageContent.section1_item5}}
                    </p>
                  </figcaption>
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="row" id="credit-unions">
        <div class="col-md-12">
          <h1>{{pageContent.section2_title}}</h1>
          <hr />
        </div>
        <div class="col-md-8">
          <h4 style="font-weight: 400">
            {{pageContent.section2_desc}}
          </h4>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="d-flex flew-row flex-wrap justify-content-center">
              <div
                class="grid"
                @click="goToLink('www.suncoastcreditunion.com')"
              >
                <figure class="effect-zoe">
                  <img
                    src="assets/images/financial-resources/credit-union/4.png"
                    alt="chase"
                    class="img-fluid"
                  />
                  <figcaption>
                    <p class="description">
                      {{pageContent.section2_item1}}
                    </p>
                  </figcaption>
                </figure>
              </div>

              <div class="grid" @click="goToLink('www.gtefinancial.com')">
                <figure class="effect-zoe">
                  <img
                    src="assets/images/financial-resources/credit-union/3.png"
                    alt="chase"
                    class="img-fluid"
                  />
                  <figcaption>
                    <p class="description">
                      {{pageContent.section2_item2}}
                    </p>
                  </figcaption>
                </figure>
              </div>

              <div class="grid" @click="goToLink('www.tampabayfederal.com')">
                <figure class="effect-zoe">
                  <img
                    src="assets/images/financial-resources/credit-union/2.png"
                    alt="chase"
                    class="img-fluid"
                  />
                  <figcaption>
                    <p class="description">
                      {{pageContent.section2_item3}}
                    </p>
                  </figcaption>
                </figure>
              </div>

              <div class="grid" @click="goToLink('www.midflorida.com')">
                <figure class="effect-zoe">
                  <img
                    src="assets/images/financial-resources/credit-union/1.png"
                    alt="chase"
                    class="img-fluid"
                  />
                  <figcaption>
                    <p class="description">
                      {{pageContent.section2_item4}}
                    </p>
                  </figcaption>
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" id="filipino-banks">
        <div class="col-md-12">
          <h1> {{pageContent.section3_title}}<br />{{pageContent.secton3_title2}}</h1>
          <hr />
        </div>
        <div class="col-md-8">
          <h4 style="font-weight: 400">
            {{pageContent.section3_desc}}
          </h4>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="d-flex flew-row flex-wrap justify-content-center">
              <div class="grid" @click="goToLink('www.pnb.com.ph')">
                <figure class="effect-zoe">
                  <img
                    src="assets/images/financial-resources/filipino-banks/1.png"
                    alt="chase"
                    class="img-fluid"
                  />
                  <figcaption>
                    <p class="description">
                      {{pageContent.section3_item1}}
                    </p>
                  </figcaption>
                </figure>
              </div>

              <div class="grid" @click="goToLink('www.metrobank.com.ph')">
                <figure class="effect-zoe">
                  <img
                    src="assets/images/financial-resources/filipino-banks/2.png"
                    alt="chase"
                    class="img-fluid"
                  />
                  <figcaption>
                    <p class="description">
                      {{pageContent.section3_item2}}
                    </p>
                  </figcaption>
                </figure>
              </div>

              <div class="grid" @click="goToLink('www.bdo.com.ph')">
                <figure class="effect-zoe">
                  <img
                    src="assets/images/financial-resources/filipino-banks/3.png"
                    alt="chase"
                    class="img-fluid"
                  />
                  <figcaption>
                    <p class="description">
                      {{pageContent.section3_item3}}
                    </p>
                  </figcaption>
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" id="remittance">
        <div class="col-md-12">
          <h1>{{pageContent.section4_title}}
            <br />{{pageContent.section4_title2}}</h1>
          <hr />
        </div>
        <div class="col-md-8">
          <h4 style="font-weight: 400">
            {{pageContent.section4_desc}}

          </h4>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="d-flex flew-row flex-wrap justify-content-center">
              <div class="grid" @click="goToLink('www.westernunion.com')">
                <figure class="effect-zoe">
                  <img
                    src="assets/images/financial-resources/remittance/1.png"
                    alt="chase"
                    class="img-fluid"
                  />
                  <figcaption>
                    <p class="description">
                      {{pageContent.section4_item1}}
                    </p>
                  </figcaption>
                </figure>
              </div>

              <div class="grid" @click="goToLink('www.remitly.com')">
                <figure class="effect-zoe">
                  <img
                    src="assets/images/financial-resources/remittance/2.png"
                    alt="chase"
                    class="img-fluid"
                  />
                  <figcaption>
                    <p class="description">
                      {{pageContent.section4_item2}}
                    </p>
                  </figcaption>
                </figure>
              </div>

              <div class="grid" @click="goToLink('www.xoom.com')">
                <figure class="effect-zoe">
                  <img
                    src="assets/images/financial-resources/remittance/3.png"
                    alt="chase"
                    class="img-fluid"
                  />
                  <figcaption>
                    <p class="description">
                      {{pageContent.section4_item3}}
                    </p>
                  </figcaption>
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br /><br /><br /><br />
    <FooterComponent :pageContent="pageFooter"></FooterComponent>
  </div>
</template>

<script>
// @ is an alias to /src
import HeaderComponent from "@/components/HeaderComponent.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import globalMixins from "@/plugins/globalMixins";

export default {
  name: "Financial Resources",
  components: {
    HeaderComponent,
    FooterComponent,
  },
  data(){
    return {
      pageContent: [],
      pageHeader:[],
      pageFooter:[],
    }
  },
  mounted() {
    const storedLanguage = localStorage.getItem("language");
  if (storedLanguage) {
    this.language = storedLanguage;
  }
  this.convertLanguage();
  },
  methods: {
    goToLink(link) {
      window.open(`https://${link}`, "_blank");
    },
    scrollToSection(id) {
      const element = document.getElementById(id);
      if (element) {
        const headerOffset = 80; // Adjust this value based on your header height
        const elementPosition =
          element.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    },
    handleHeaderClick() {
      this.convertLanguage();
    },
    async convertLanguage() {
      const storedLanguage = localStorage.getItem("language");
      if (storedLanguage) {
        this.language = storedLanguage;
      }

      let lang = this.language;
      if (lang === 'us') {
        lang = 'en';
      }

      console.log("Updated content:", lang);

      const converted = globalMixins.financial[lang];

      const pageHeader = globalMixins.pageHeader[lang];

      const pageFooter = globalMixins.pageFooter[lang];

      if (converted) {
        this.pageContent = {
          ...this.pageContent,
          ...converted,
        };
      
        this.pageHeader={
          ...this.pageHeader,
          ...pageHeader,
        }
        this.pageFooter={
          ...this.pageFooter,
          ...pageFooter,
        }
        
      }  
    },
  },
};
</script>


<style>
.grid {
  position: relative;
  margin: 0 auto;
  padding: 1em 0 4em;
  max-width: 1000px;
  list-style: none;
  text-align: center;
}

/* Common style */
.grid figure {
  position: relative;
  float: left;
  overflow: hidden;
  margin: 10px 1%;
  width: 100%;
  text-align: center;
  cursor: pointer;
}
.grid figure:hover {
  background: #2881F4;
}

.grid figure:hover img {
  background: #2881F4;
  opacity: 0 !important;
}

.grid figure img {
  position: relative;
  display: block;
  min-height: 100%;
  max-width: 100%;
  opacity: 0.8;
}

.grid figure figcaption {
  padding: 2em;
  color: #fff;
  text-transform: uppercase;
  font-size: 1.25em;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.grid figure figcaption::before,
.grid figure figcaption::after {
  pointer-events: none;
}

.grid figure figcaption,
.grid figure figcaption > a {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* Anchor will cover the whole item by default */
/* For some effects it will show as a button */
.grid figure figcaption > a {
  z-index: 1000;
  text-indent: 200%;
  white-space: nowrap;
  font-size: 0;
  opacity: 0;
}

.grid figure h2 {
  word-spacing: -0.15em;
  font-weight: 300;
}

.grid figure h2 span {
  font-weight: 800;
}

.grid figure h2,
.grid figure p {
  margin: 0;
}

.grid figure p {
  letter-spacing: 1px;
  font-size: 68.5%;
}
/*---------------*/
/***** Zoe *****/
/*---------------*/

figure.effect-zoe figcaption {
  top: auto;
  bottom: auto;
  padding: 1em;
  height: 4em;
  color: #3c4a50;
  -webkit-transition: -webkit-transform 0.35s;
  transition: transform 0.35s;
  -webkit-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100%, 0);
}

figure.effect-zoe h2 {
  float: left;
}

figure.effect-zoe p.icon-links a {
  float: right;
  color: #3c4a50;
  font-size: 1.4em;
}

figure.effect-zoe:hover p.icon-links a:hover,
figure.effect-zoe:hover p.icon-links a:focus {
  color: #252d31;
}

figure.effect-zoe p.description {
  position: absolute;
  bottom: 6em;
  padding: 2em;
  color: #fff;
  background: #2881F4;
  text-transform: none;
  left: 0;
  font-size: 90%;
  opacity: 0;
  -webkit-transition: opacity 0.35s;
  transition: opacity 0.35s;
  -webkit-backface-visibility: hidden; /* Fix for Chrome 37.0.2062.120 (Mac) */
}

figure.effect-zoe h2,
figure.effect-zoe p.icon-links a {
  -webkit-transition: -webkit-transform 0.35s;
  transition: transform 0.35s;
  -webkit-transform: translate3d(0, 200%, 0);
  transform: translate3d(0, 200%, 0);
}

figure.effect-zoe p.icon-links a span::before {
  display: inline-block;
  padding: 8px 10px;
  font-family: "feathericons";
  speak: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-eye::before {
  content: "\e000";
}

.icon-paper-clip::before {
  content: "\e001";
}

.icon-heart::before {
  content: "\e024";
}

figure.effect-zoe h2 {
  display: inline-block;
}

figure.effect-zoe:hover p.description {
  opacity: 1;
}

figure.effect-zoe:hover figcaption,
figure.effect-zoe:hover h2,
figure.effect-zoe:hover p.icon-links a {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

figure.effect-zoe:hover h2 {
  -webkit-transition-delay: 0.05s;
  transition-delay: 0.05s;
}

figure.effect-zoe:hover p.icon-links a:nth-child(3) {
  -webkit-transition-delay: 0.1s;
  transition-delay: 0.1s;
}

figure.effect-zoe:hover p.icon-links a:nth-child(2) {
  -webkit-transition-delay: 0.15s;
  transition-delay: 0.15s;
}

figure.effect-zoe:hover p.icon-links a:first-child {
  -webkit-transition-delay: 0.2s;
  transition-delay: 0.2s;
}
@media (max-width: 767px) {
  .financial-container img {
    margin: 0 auto;
  }
}
</style>